import React, { memo } from "react";

import { Modal } from "@UI/Components/Modal/Modal";
import { VStack } from "@UI/Components/Stack/Stack";
import { Heading } from "@UI/Components/Heading/Heading";
import { Icon } from "@UI/Components/Icon/Icon";
import { CircleExclamation } from "@UI/Components/Icons/CicleExclamation";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "../../messages";

export interface IContactInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Answers a submit blocked by contact info. One wording whichever rule tripped,
 * and a CTA that only closes — the text is never altered for the user.
 */
export const ContactInfoModal = memo(
  ({ isOpen, onClose }: IContactInfoModalProps) => (
    <Modal isOpen={isOpen} onClose={onClose}>
      <VStack spacing={4} textAlign="center">
        <Icon
          as={CircleExclamation}
          width="40px"
          height="40px"
          color="gray.800"
        />
        <Heading size="md">
          <FormattedMessage
            {...messages["taskCreation.ContactInfoModal.title"]}
          />
        </Heading>
        <Text color="gray.600">
          <FormattedMessage {...messages["taskCreation.ContactInfoModal.body"]} />
        </Text>
        <Button
          width="100%"
          colorScheme="seaGreen"
          onClick={onClose}
          marginTop="8px"
        >
          <FormattedMessage
            {...messages["taskCreation.ContactInfoModal.editButton"]}
          />
        </Button>
      </VStack>
    </Modal>
  )
);

ContactInfoModal.displayName = "ContactInfoModal";
